<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { icons, type IconName } from "../icons";

const props = withDefaults(defineProps<{
  icon: IconName;
}>(), {
  icon: "tick",
});

const loadedIcon = computed(() => defineAsyncComponent(icons[props.icon]));
</script>

<template>
  <component
    :is="loadedIcon"
    v-if="loadedIcon"
    class="icon-wrapper"
    :name="icon"
    v-bind="$attrs"
  />
</template>
